import React from 'react';
import { cn } from '@design-system';
import { isNullUndefinedOrEmpty } from '@shared';
import { WaterlilyLogo } from './WaterlilyLogo';

interface CompanyLogoContainerProps {
  organizationDisplayName: string | null | undefined;
  waterlilyFallback?: 'text' | 'logo';
  containerClassName?: string;
  organizationNameClassName?: string;
  subtextClassName?: string;
  onClick?: () => void;
}

function formatOrgDisplayName(input: string): string {
  return input.replace(/\b[a-z]/g, (char, index, sentence) => {
    // Check if the previous character is an apostrophe
    if (index > 0 && sentence[index - 1] === "'") {
      return char;
    }
    return char.toUpperCase();
  });
}

const CompanyLogoContainer: React.FC<CompanyLogoContainerProps> = ({
  organizationDisplayName,
  waterlilyFallback = 'text',
  containerClassName,
  organizationNameClassName,
  subtextClassName,
  onClick,
}) => {
  const waterlilyBranding =
    waterlilyFallback === 'logo' ? (
      <WaterlilyLogo className="h-10 w-auto" />
    ) : (
      <div className="mt-2 text-2xl font-semibold text-gray-950 md:text-3xl">Waterlily</div>
    );

  return (
    <div
      className={cn(containerClassName, 'mr-5 flex min-w-max flex-col items-start', {
        'cursor-pointer': onClick,
      })}
      id="white-label-container"
      onClick={onClick}
    >
      {!isNullUndefinedOrEmpty(organizationDisplayName) ? (
        <>
          {/** Do not remove whitelabel-logo id, it is used for pdf report generation */}
          <div
            id="whitelabel-logo"
            className={cn(
              'max-w-56 leading-tight! sm:max-w-max',
              {
                'text-primary-dark text-sm font-semibold md:text-base': !organizationNameClassName,
              },
              organizationNameClassName,
            )}
          >
            {formatOrgDisplayName(organizationDisplayName)}
          </div>
          <div
            className={subtextClassName ? subtextClassName : 'text-foreground text-xs md:text-sm'}
          >
            powered by Waterlily
          </div>
        </>
      ) : (
        waterlilyBranding
      )}
    </div>
  );
};

export default CompanyLogoContainer;
